import { render, staticRenderFns } from "./RecipientInformation.vue?vue&type=template&id=1c5eb52f&scoped=true&"
import script from "./RecipientInformation.vue?vue&type=script&lang=js&"
export * from "./RecipientInformation.vue?vue&type=script&lang=js&"
import style0 from "./RecipientInformation.vue?vue&type=style&index=0&id=1c5eb52f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5eb52f",
  null
  
)

export default component.exports